import * as app_js from './app.js'
import * as checkout_html from './checkout.html'

export default [app_js, checkout_html]
